import { Action, createReducer, on } from '@ngrx/store';
import { Country } from '../../models/country.model';
import * as fromActionsCountries from './../actions/country.actions';
import * as fromActionsRoles from './../actions/role.actions';
import { Role } from '../../models/role';


export const parametersFeatureKey = 'parameters';

export interface State {
  countries: {
    loading: boolean;
    loaded: boolean;
    entities: Country[]
  };
  roles: {
    loading: boolean;
    loaded: boolean;
    entities: Role[];
  };
}

export const initialState: State = {
  countries: {
    loading: false,
    loaded: false,
    entities: []
  },
  roles: {
    loading: false,
    loaded: false,
    entities: []
  }
};

const parametersReducer = createReducer(
  initialState,
  on(fromActionsCountries.loadCountries,
    (state) => ({
      ...state, countries: {
        entities: [...state.countries.entities],
        loaded: false,
        loading: true
      }
    })
  ),
  on(fromActionsCountries.loadCountriesSuccess,
    (state, { entities }) => ({
      ...state, countries: {
        entities: [...entities], loading: false, loaded: true
      }
    })
  ),
  on(fromActionsRoles.loadRolesSuccess,
    (state, { entities}) => ({
      ...state, roles: {
        entities: [...entities], loading: false, loaded: true
      }
    })
    )
);

export function reducer(state: State | undefined, action: Action) {
  return parametersReducer(state, action);
}
